import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';


const useStyles = makeStyles((theme) => ({
    searchWrap: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '6px 0 2px',
    },
    root: {
        padding: '3px 5px 3px 14px',
        display: 'flex',
        alignItems: 'center',
        width: "100%",
        maxWidth: 620,
        border: '1px solid #d5e3ec',
        borderRadius: 8,
        boxShadow: '0 8px 22px rgba(38, 50, 56, 0.08)',
        backgroundColor: '#ffffff',
    },
    input: {
        flex: 1,
        color: '#263238',
        fontSize: 13,
        '& input': {
            padding: '9px 0',
        },
        '& input::placeholder': {
            color: '#78909c',
            opacity: 1,
        },
    },
    iconButton: {
        padding: '9px 12px',
        borderRadius: 6,
        color: '#ffffff',
        backgroundColor: '#2f7ea8',
        fontSize: 13,
        fontWeight: 700,
        gap: 6,
        minWidth: 98,
        '&:hover': {
            backgroundColor: '#286f95',
        },
        '&.Mui-disabled': {
            color: '#ffffff',
            backgroundColor: '#8bb8cf',
        },
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

export default function SearchArea(props) {
    const classes = useStyles();
    const [cedula, setCedula] = React.useState(props.value || "");
    const loading = Boolean(props.loading);

    React.useEffect(() => {
        setCedula(props.value || "");
    }, [props.value]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !loading) {
          props.searchAction(cedula);
          event.preventDefault();
          event.stopPropagation();
        }
      }
    return (
        <React.Fragment>
            <Grid container spacing={0} alignItems="center" className={classes.searchWrap}>
                <Grid item xs={12} md={7} lg={6}>
                  <Paper component="form" className={classes.root}>
                    <InputBase
                        className={classes.input}
                        placeholder="Ingrese su número de cédula"
                        inputProps={{ 'aria-label': 'Ingrese su número de cédula' }}
                        value={cedula}
                        disabled={loading}
                        onChange={(e) => {
                            setCedula(e.target.value);
                        }}
                        onKeyDown={handleKeyDown}
                    />
                    <IconButton
                        className={classes.iconButton}
                        aria-label="buscar"
                        disabled={loading}
                        onClick={() => { props.searchAction(cedula); }}
                    >
                        {loading ? <CircularProgress size={22} /> : <SearchIcon />}
                        {loading ? 'Buscando...' : 'Buscar'}
                    </IconButton>
                  </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
